import {i18n} from '@/plugins/i18n';
import {arrayTableFieldTemplate} from "@/views/wallets/AyandeWallets/Admin/datatable/errors-columns";

export default [
    {
        field: 'id',
        title: i18n.t('label.hashid'),
        width: 40,
        textAlign: 'center',
    },
    {
        field: 'user',
        title: i18n.t('label.user'),
        width: 40,
        template: (row) => '<a href="/users/' + row.user.id + '/details">'+row.user.full_name+'</a>',
        textAlign: 'center',
    },
    {
        field: 'destination_iban',
        title: i18n.t('label.destination_account'),
        textAlign: 'center',
    },
    {
        field: 'source_account_number',
        title: i18n.t('label.source_account_number'),
        template: row => {
            return `
                <span>
                    ${row.wallet_bank_account.number}
                </span>
            `;
        },
        textAlign: 'center',
    },
    {
        field: 'bank_name_fa',
        title: i18n.t('label.wallet_errors_columns.bank_name'),
        width: 50,
        template: row => {
            return `
                <span>
                    ${row.wallet_bank_account.bank_name_fa}
                </span>
            `;
        },
        textAlign: 'center',
    },
    {
        field: 'wallet_transaction_id',
        title: i18n.t('label.transaction_id'),
        width: 40,
        textAlign: 'center',
    },
    {
        field: 'wallet_id',
        title: i18n.t('search_fields.common.wallet_id'),
        width: 40,
        textAlign: 'center',
    },
    {
        field: 'created_at',
        title: i18n.t('label.created_at'),
        textAlign: 'center',
    },
    {
        field: 'payment_date',
        title: i18n.t('label.payment_date'),
        textAlign: 'center',
    },
    {
        field: 'request',
        title: i18n.t('label.request'),
        template: (row, index) => {
            return arrayTableFieldTemplate(row.request, 'request', 'fa-info', index, -1)
        },
        width: 50,
        textAlign: 'center',
    },
    {
        field: 'response',
        title: i18n.t('label.response'),
        width: 50,
        template: (row, index) => {
            return arrayTableFieldTemplate(row.response, 'response', 'fa-eye', index, -2)
        },
        textAlign: 'center',
    },
]
